import templateUrl from "./billing-address.html";
import gridHeight from "../../core/shared-service/grid-utils";
import _ from "lodash";

export const billingAddress = {
    templateUrl,
    bindings: {
        addNewButton: '<',
        invitedEntity: '<', // Les données d'une entité.
        opened: '<' // Indique si le panel est ouvert ou fermé par défaut
    },
    controllerAs: 'ctrl',
    controller: class BillingAddressCtrl {
        /*@ngInject*/
        constructor($scope, $state, $translate, AuthSvc, DateService, uiGridExporterService, uiGridExporterConstants, BillingAddressSvc, $location, invitedEntitySvc, logger, $uibModal, SessionSvc, PrincipalSvc) {
            this.$scope = $scope;
            this.$state = $state;
            this.AuthSvc = AuthSvc;
            this.$translate = $translate;
            this.gridApi = null;
            this.uiGridExporterConstants = uiGridExporterConstants;
            this.invitedEntitySvc = invitedEntitySvc;
            this.logger = logger;
            this.$uibModal = $uibModal;
            this.SessionSvc = SessionSvc;
            this.PrincipalSvc = PrincipalSvc;
            this.BillingAddressSvc = BillingAddressSvc;
            this.DateService = DateService;
            this.uiGridExporterService = uiGridExporterService;

        }

        $onInit() {
            this.legalEntity = this.invitedEntity.legalEntity; // Utiliser l'opérateur de chaînage optionnel pour éviter les erreurs si invitedEntity est indéfini
            var defaultCellTemplate = `<a class="grid-cell-link" ui-sref="app.principal.consult.edit-billing_address({ forEdit: true, billingAddressId :row.entity.id ,legalEntityId:${this.legalEntity.id}})">
                  <div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div>
                </a>`;
            this.showCreationbilling = this.addNewButton && this.AuthSvc.isAuthorized('CONFIGURATOR');

            this.getAllBillingAddress();

            this.gridOptions = {
                columnDefs: [
                    {
                        name: 'address',
                        displayName: 'kiss_seller.edit.billing_address.address',
                        headerCellFilter: 'translate',
                        cellClass: 'defaultcursor',
                        cellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,

                    },
                    {
                        name: 'getPdpReDate("startDate")',
                        displayName: 'kiss_seller.edit.pdp_re.start_date',
                        headerCellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default text-center',
                    },
                    {
                        name: 'getPdpReDate("endDate")',
                        displayName: 'kiss_seller.edit.pdp_re.end_date',
                        headerCellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'cursor-default text-center',
                    },
                ],
                exporterOlderExcelCompatibility: true,
                useExternalPagination: true,
                useExternalSorting: false,
                onRowClicked: this.myRowClickedHandler,
                gridMenuTitleFilter: this.$translate,

                onRegisterApi: gridApi => {
                    this.gridApi = gridApi;
                    gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                        this.getAllBillingAddress((page - 1), size);
                    });
                },
                enableSorting: true,
                enableGridMenu: false,
                enableColumnMenus: false,
                paginationPageSizes: [5, 10, 20],
                paginationPageSize: 5,
                data: {},
                enableRowSelection: false,

            };
        }

        getAllBillingAddress(page = 0, size = 5) {
            this.containerPromise = this.BillingAddressSvc.getAllBillingAddress(page, size, this.legalEntity.id);
            this.containerPromise.then(
                data => {
                    if (data.totalElements !== 0) {
                        this.gridOptions.data = data.billingAddresses;
                        this.gridOptions.totalItems = data.totalElements
                    }
                },
                () => {
                    this.logger.error('error.search');
                }
            );
        }

        openCreateNewBillingAddress() {
             this.$state.go('app.principal.consult.billing_address', {legalEntityId: this.legalEntity.id});
        }

        getGridHeight() {
            return gridHeight(this.gridApi);
        }

        exportCsv() {
            this.gridOptions.exporterCsvFilename = 'Adresse_electronique_de_facturation' + this.DateService.formatAsYMD_HM(new Date()) + '.csv';
            this.gridOptions.exporterHeaderFilter = this.$translate.instant;

            this.BillingAddressSvc.getAllBillingAddress(0, this.gridOptions.totalItems, this.legalEntity.id).then(data => {
                let gridApi2 = _.cloneDeep(this.gridApi);
                gridApi2.grid.modifyRows(data.billingAddresses);
                this.uiGridExporterService.csvExport(gridApi2.grid.api.grid, this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
            });
        }
    }
};
